import { CalendarListSettingsStore } from './schema/CalendarListSettingsStore';
import { createStore } from 'satcheljs';

export const getStore = createStore<CalendarListSettingsStore>('calendarListSettingsStore', {
    selectedView: 'Agenda',
});
